var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classList,style:(_vm.styles),attrs:{"outlined":_vm.outlined,"disabled":_vm.disabled,"color":_vm.color},on:{"click":_vm.setApplySearch}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }